var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.msgs.length > 0)?_c('div',{staticClass:"v-notice-list"},_vm._l((_vm.msgs),function(msg){return _c('Notice',{key:msg.name,attrs:{"type":msg.type,"icon":msg.icon,"content":msg.content,"duration":msg.duration,"closable":msg.closable,"name":msg.name,"transition-name":msg.transitionName,"on-close":msg.onClose}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }